module.exports = __webpack_public_path__ + "img/David_Ben_KayB.1f57f7b4.jpg";